



















































































































































import { Component, Vue } from 'vue-property-decorator';
import { NamedContact } from '@/store/ContactStore';

@Component
export default class Contact extends Vue {
  get doug(): NamedContact {
    return this.$store.getters['contact/doug'] || ({ duties: [] } as NamedContact);
  }

  get ryan(): NamedContact {
    return this.$store.getters['contact/ryan'] || ({ duties: [] } as NamedContact);
  }

  get mayra(): NamedContact {
    return this.$store.getters['contact/mayra'] || ({ duties: [] } as NamedContact);
  }

  get susan(): NamedContact {
    return this.$store.getters['contact/susan'] || ({ duties: [] } as NamedContact);
  }

  get mayraList(): string[] {
    return this.mayra.duties || [];
  }

  get susanList(): string[] {
    return this.susan.duties || [];
  }

  get fields() {
    return [
      {
        key: 'lastName',
        label: 'Last Name'
      },
      {
        key: 'firstName',
        label: 'First Name'
      },
      {
        key: 'title',
        label: 'Title'
      },
      {
        key: 'email',
        label: 'Email'
      },
      {
        key: 'phone',
        label: 'Phone'
      }
    ];
  }

  get contacts() {
    return this.$store.getters['contact/contacts'];
  }

  public async mounted() {
    await this.$store.dispatch('contact/loadContacts');
  }
}
